// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-ban[data-v-c48058b6]{height:2.8125vw;line-height:2.8125vw;background:#232323;border:.10417vw solid #161616;border-radius:.10417vw;text-indent:1.25vw}", ""]);
// Exports
module.exports = exports;
